import { FilterFormValues } from "../types"

export function generateQueryParams(values: FilterFormValues): URLSearchParams {
	const queryParams = new URLSearchParams()

	for (const [key, value] of Object.entries(values)) {
		if (!value) continue
		if (Array.isArray(value)) {
			const [min, max] = value
			queryParams.set(`${key}_from`, String(min))
			queryParams.set(`${key}_to`, String(max))
		} else if (value) {
			queryParams.set(key, String(value))
		}
	}
	return queryParams
}
